import i18next from "i18next";
import { useBreakpointValue } from "native-base";
export var headerHeightByBreakpoint = {
  base: "77px",
  md: "91px"
};
export function useHeaderHeight() {
  // Removed store usage because it is giving undefined in the start causing layout issues
  // i18next.exists giving true for empty strings also. So had to use !!
  var globalBannerMessage = !!i18next.t("header.richtext.globalBannerMessage") || !!i18next.t("header.label.careers");
  return useBreakpointValue({
    base: globalBannerMessage ? "115px" : "77px",
    md: globalBannerMessage ? "131px" : "91px"
  });
}